import {createModel} from '@@/package/utils/ModelUtil';

export class LearningTaskModel {
    constructor(
        public id: number = 0,
        public langType: string = "",
        public type: string = "",
        public taskMapUserId: number = 0,
        public completeFlag: boolean = false,
        public learningTime: number = 0,
        public submissionFlag: boolean = false
    ) {}

    public static create(model: Partial<LearningTaskModel>): LearningTaskModel {
        return createModel<LearningTaskModel>(LearningTaskModel, {
            ...model
        });
    }
}
